import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getIn, useFormikContext } from 'formik';

import FormList from 'core/components/form-list';
import { useDisabledState } from 'common/disabled-context';
import Location from './location';
import AddLocation from './add-location';
import { ConfirmLocationDeleteModal } from './confirm-location-delete-modal';
import { EditLocationModal } from './edit-location-modal';
import { FarmRiskType } from '@ourbranch/lookups';
import { useFarmOpenSections } from 'common/hooks/farm-open-sections-context';

const Locations = ({ disabled = true, ...rest }) => {
  const { setActiveForm } = useDisabledState();
  const { values } = useFormikContext();
  const { addOpenLocation } = useFarmOpenSections();

  const [locationIndexToRemove, setLocationIndexToRemove] = useState(null);
  const [locationIndexToEdit, setLocationIndexToEdit] = useState(null);

  useEffect(() => {
    const farmLocations = getIn(values, 'farmLocations');

    // If there is only one location, one risk, and no coverageF, set the active form to the initial risk
    if (
      farmLocations.length === 1 &&
      farmLocations[0].risks.length === 1 &&
      [FarmRiskType.Fo6Scheduled].includes(farmLocations[0].risks[0].type) &&
      farmLocations[0].risks[0].coverages.coverageF.length === 0
    ) {
      setActiveForm('farmLocations[0].risks[0]');
    }
  }, []);

  return (
    <>
      {locationIndexToRemove !== null && (
        <ConfirmLocationDeleteModal
          onClose={() => setLocationIndexToRemove(null)}
          locationIndexToRemove={locationIndexToRemove}
        />
      )}
      {locationIndexToEdit !== null && (
        <EditLocationModal onClose={() => setLocationIndexToEdit(null)} index={locationIndexToEdit} />
      )}
      <FormList
        disabled={disabled}
        id="farmLocations"
        item={Location}
        addForm={AddLocation}
        title="Locations"
        singular="location"
        plural="locations"
        onAdd={() => {
          // This will set new location as active form and disable all other forms
          const locations = getIn(values, 'farmLocations');
          setActiveForm(`farmLocations[${locations.length}]`);
          addOpenLocation(locations.length);
        }}
        setLocationIndexToRemove={setLocationIndexToRemove}
        setLocationIndexToEdit={setLocationIndexToEdit}
        {...rest}
      />
    </>
  );
};

Locations.propTypes = {
  disabled: PropTypes.bool
};

Locations.defaultProps = {
  disabled: false
};

export default Locations;
